import React, { PropTypes } from 'react';
import map from 'lodash/map';
import { v4 } from 'node-uuid';

const Gallery = ({ list, classes, tile, onTileSelect, keyField }) => {
  const TileComponent = tile;
  return (<div className={classes}>
    { map(list, item => <TileComponent onClick={onTileSelect} key={item[keyField] || v4()} {...item}/>) }
  </div>);
};

Gallery.propTypes = {
  list: PropTypes.array,
  classes: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  tile: PropTypes.any,
  onTileSelect: PropTypes.func,
  keyField: PropTypes.string,
};

export default Gallery;



// WEBPACK FOOTER //
// ./common/components/gallery.jsx